var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-gray-500 text-center"},[_vm._v(_vm._s(_vm.$t('text.noItems')))])
}
var staticRenderFns = []

export { render, staticRenderFns }